// 现金保留 2位小数
export function filter2(val) {
  if(val===null || val===undefined || typeof val==='string'){
    return val
  }
  return val.toFixed(2)
}

// 现金保留 2位小数(带 +  - )
export function filterMoney(val) {
  if(val===null || val===undefined || typeof val==='string'){
    return val
  }
  if(val < 0){
    return '-' + (val * -1).toFixed(2)
  }else {
    return '+' + val.toFixed(2)
  }
}

// 金币保留 4位小数
export function filter4(val) {
  if(val===null || val===undefined || typeof val==='string'){
    return val
  }
  return val.toFixed(4)
}

// 金币保留 4位小数(带 +  - )
export function filterCoin(val) {
  if(val===null || val===undefined || typeof val==='string'){
    return val
  }
  if(val < 0){
    return '-' + (val * -1).toFixed(4)
  }else {
    return '+' + val.toFixed(4)
  }
}


// 时间格式化
export function dataFormat(value, fmt) {
  let getDate = new Date(value);
  let o = {
    'M+': getDate.getMonth() + 1,                   //月份
    'd+': getDate.getDate(),                        //日
    'h+': getDate.getHours(),                       //小时
    'm+': getDate.getMinutes(),                     //分
    's+': getDate.getSeconds(),                     //秒
    'q+': Math.floor((getDate.getMonth() + 3) / 3), //季度
    'S': getDate.getMilliseconds()                  //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt;
}

